import Icon from '@/components/snippets/icon/icon'
import { FilterItem } from 'libs/searchspring/components/collection/filters/FilterItem'
import { useFilters } from 'libs/searchspring/hooks/useFilters'

export function FilterDrawer({ buttonClass = 'btn btn-secondary btn-inline group-data-visible:btn-primary', id = 'filters' }) {
  const {
    handleOpenFilters,
    handleCancelFilters,
    handleClearFilters,
    handleToggleFilter,
    handleApplyFilters,
    initialFilters,
    activeFilters,
    fetchedFilters
  } = useFilters()

  // Get count of active filters from Set
  const activeFilterCount = activeFilters?.size

  return (
    <x-modal className="group data-visible:z-1" data-id={id}>
      <button
        className={buttonClass}
        data-modal-role="toggle"
        aria-label="Open Filter Drawer"
        type="button"
        data-modal-parent={id}
        onClick={handleOpenFilters}
      >
        <Icon id="filter" className="icon-lg" />
        <span className={'text-sm uppercase flex items-center gap-1 pr-3 -mx-1'}>Filter{activeFilterCount > 0 ? <span className={'paragraph-md flex justify-center items-center bg-brand-black text-brand-white rounded-full size-6 text-center'}>{activeFilterCount}</span> : ''}</span>
      </button>
      <div
        className="fixed inset-0 z-50 flex items-end transition-opacity duration-150 opacity-0 pointer-events-none group-data-visible:pointer-events-auto group-data-visible:opacity-100"
      >
        <div className="relative z-50 p-4 md:p-6 pt-10 md:pt-12 flex flex-col transition-all md-max:scallop md:h-full md:scallop-right md-max:translate-y-full md:-translate-x-full w-full md:max-w-xl md-max:!h-[90dvh] bg-neutral-light group-data-visible:translate-y-0 group-data-visible:md:translate-x-0">
          <div className="flex justify-between pt-4 pb-8 bg-neutral-light">
            <p className="paragraph-base">
              Filters
            </p>
            <button data-modal-role="close" aria-label="Close Filter Drawer" data-modal-parent={id} type="button">
              <Icon id="close" />
            </button>
          </div>
          {/* <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} /> */}
          <div className="flex flex-col flex-grow gap-4 pr-1 overflow-y-auto overscroll-contain">
            {initialFilters.map((filter) => (
              <FilterItem
                filter={filter}
                onFilter={handleToggleFilter}
                fetchedFilters={fetchedFilters}
                activeFilters={activeFilters}
                key={filter.field}
              />
            ))}
          </div>
          <div className="flex flex-col gap-2 paragraph-md">
            <div className={'flex flex-row gap-2'}>
              {activeFilters.size > 0 && (
                <button
                data-modal-role="close"
                data-modal-parent={id}
                aria-label="Clear All Filters"
                type="button"
                className="w-full uppercase btn btn-primary-outline btn-md"
                onClick={handleClearFilters}
              >
                Clear All
              </button>
              )}
              <button
                data-modal-role="close"
                data-modal-parent={id}
                aria-label="Cancel Filter Changes"
                type="button"
                className="w-full uppercase btn btn-primary-outline btn-md"
                onClick={handleCancelFilters}
              >
                Cancel
              </button>
            </div>
            <button
              data-modal-role="close"
              data-modal-parent={id}
              aria-label="Apply Filter Changes"
              type="button"
              onClick={handleApplyFilters}
              className="justify-center flex-grow uppercase btn btn-primary btn-md"
            >
              Apply Filters
            </button>
          </div>
        </div>
        <button
          data-modal-parent={id}
          data-modal-role="close"
          aria-label="Close Filter Drawer"
          type="button"
          class="fixed inset-0 transition-all duration-300 opacity-0 pointer-events-none bg-neutral-black/30 backdrop-blur-lg group-data-visible:pointer-events-auto group-data-visible:opacity-100">
        </button>
      </div>

    </x-modal>
  )
}
